module.exports = fox._r("images/join/promotion_bg.png", __webpack_public_path__ + "images/join/promotion_bg.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join/promotion_bg.png
// module id = 1067
// module chunks = 4